import {domReady} from "./functions/domReady";
import {Sticky} from 'sticky-ts'
import {BackButton} from "./modules/back";
import {QuestionSelect} from "./modules/q-select";
import {FormFixer} from "./modules/form-fixer";
import {HalfWrapper} from "./modules/half-wrapper";
import {Sliders} from "./modules/sliders";
import {ScrollTo} from "./modules/scroll-to";
// import {PrettyCheckbox} from "./modules/pretty-checkbox";

import '../styles/front.scss';

domReady(async () => {
    BackButton.init();
    QuestionSelect.init();
    FormFixer.init();
    HalfWrapper.init();
    Sliders.init();
    ScrollTo.init();
    // PrettyCheckbox.init();

    new Sticky('.site-header', {
        // marginTop: 50,
        wrap: true,
        stickyClass: 'site-header--sticky'
    });
});
